import { styled } from '@grupoboticario/flora-react'
import { Link } from 'react-router-dom'
import { Box, keyframes } from '@grupoboticario/flora-react'

export const Wrapper = styled('div', {
  backgroundColor: '$backgroundPrimary',
  borderColor: '$backgroundSecondary',
  borderRadius: '$small',
  borderStyle: 'solid',
  borderWidth: '$thin',
  boxSizing: 'border-box',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'space-between',
  minHeight: '316px',
  padding: '$4 $2 $2',
  textDecoration: 'none',
  width: '100%',
  '@tablet': {
    padding: '$4 $4 $2',
  },
})

export const LinkWrapper = styled(Link, {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  padding: '0',
  textDecoration: 'none',
})

export const ImageWrapper = styled('div', {
  alignItem: 'start',
  alignItems: 'center',
  display: 'flex',
  height: '96px',
  justifyContent: 'center',
  marginBottom: '$1',
  overflow: 'hidden',
  position: 'relative',
  width: '100%',

  '& > *': {
    height: '100%',
    width: '100%',
  },

  img: {
    objectFit: 'contain',
    height: '100%',
    width: '100%',
  },

  'svg.control-point-icon': {
    background: '$actionNavigationAltDisabled',
    borderRadius: '$pill',
    bottom: '7px',
    color: '$nonInteractiveAltPredominant',
    fontSize: '18px',
    padding: '1px',
    position: 'absolute',
    right: '7px',
  },
})

export const Name = styled('div', {
  marginBottom: '$1',
  paddingTop: '$1',
})

export const Tags = styled('div', {
  display: 'block',
  overflow: 'hidden',
})

export const Price = styled('div', {
  marginBottom: '$1',
})

export const DiscountPrice = styled('span', {
  textDecoration: 'line-through',
  textDecorationColor: '$error-standard',
})

const buttonsSharedStyles = {
  '> span': {
    width: '100%',
  },
  '&::before': {
    minWidth: '$8',
    minHeight: '$8',
  },
}

export const positionButtonOverrideStyles = {
  'button[data-to="previous"]': {
    left: '-$4 !important',
    ...buttonsSharedStyles,
  },
  'button[data-to="next"]': {
    right: '-$4 !important',
    ...buttonsSharedStyles,
  },
}

const shine = keyframes({
  '0%': {
    backgroundPosition: '-200px 0',
  },
  '100%': {
    backgroundPosition: 'calc(200px + 100%) 0',
  },
})

export const Skeleton = styled(
  ({ children, ...props }: { children: React.ReactNode }) => <Box {...props}>{children}</Box>,
  {
    display: 'inline-block',
    background: '#f6f7f8',
    backgroundImage: 'linear-gradient(90deg, #f6f7f8 0px, #edeef1 40px, #f6f7f8 80px)',
    backgroundSize: '200px 100%',
    backgroundRepeat: 'no-repeat',
    animation: `${shine} 1.2s infinite linear`,
    borderRadius: '$4',
    margin: '$0.5 0',
  },
)
